// Shared bare-button style used by the header/drawer and the auth toggles.
export const navBtnStyle: React.CSSProperties = {
  background: "none", border: "none", padding: 0,
  cursor: "pointer", color: "inherit", font: "inherit", textAlign: "left",
};
